import { RootState } from "../../../store";

export const roleSelector = (state: RootState) => {
    return state.role.roleData;
};

export const getUserRole = (state: RootState) => {
    return roleSelector(state);
};
